import { render } from "./TestAttachments.vue?vue&type=template&id=45fc26f8"
import script from "./TestAttachments.vue?vue&type=script&lang=js"
export * from "./TestAttachments.vue?vue&type=script&lang=js"

import "./TestAttachments.vue?vue&type=style&index=0&id=45fc26f8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/TestAttachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45fc26f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45fc26f8', __exports__)) {
    console.log('reload')
    api.reload('45fc26f8', __exports__)
  }
  
  module.hot.accept("./TestAttachments.vue?vue&type=template&id=45fc26f8", () => {
    console.log('re-render')
    api.rerender('45fc26f8', render)
  })

}


export default __exports__